import { render, staticRenderFns } from "./postuser.vue?vue&type=template&id=02b11602&scoped=true&"
import script from "./postuser.vue?vue&type=script&lang=js&"
export * from "./postuser.vue?vue&type=script&lang=js&"
import style0 from "./postuser.vue?vue&type=style&index=0&id=02b11602&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02b11602",
  null
  
)

export default component.exports